<template>
  <div style="margin: 25px">
    <vue-good-table
      :columns="hareketListesicolumns"
      :rows="hareketListesi"
      :rtl="dir"
      max-height="350px"
      :fixed-header="true"
      :row-style-class="rowStyleClassFn"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <div v-if="props.column.field === 'TRANSDATE'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.TRANSDATE }}</span>
        </div>
      </template>

      <!-- pagination -->
    </vue-good-table>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  data() {
    return {
      dir: false,

      hareketListesicolumns: [
        {
          label: "Tarih",
          field: "STOKHAREKET_TARIH",
        },
        {
          label: "Fiş No",
          field: "ROOTRECEIPTNO",
        },
        {
          label: "İşlem",
          field: "TRANSTYPENAME",
        },
        {
          label: "Firma",
          field: "ACTNAME",
        },
        {
          label: "Açıklama",
          field: "DESCRIPTION",
        },
        {
          label: "Giriş",
          field: "GIRIS",
        },
        {
          label: "Çıkış",
          field: "CIKIS",
        },
      ],
      hareketListesi: [],
    };
  },
  methods: {
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    hareket() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_StockEktsre_HareketListe(args, function (err, result) {
          if (result.INT_Ls_StockEktsre_HareketListeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_StockEktsre_HareketListeResult);
          vm.hareketListesi = vm.veriler;
          // vm.rowData = vm.veriler;
        });
      });
    },
  },
  created() {
    this.hareket();
  },
};
</script>
<style lang="scss">
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
</style>